import * as React from 'react'

import { useLocation } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import URI from '../../../misc/classes/URI'
import { IPageResponse } from '../../../models/Pages'
import { locale } from '../../../state/locale/atoms/locale'
import PageWrapper from '../../_layout/PageWrapper'
import { Error404 } from '../../organisms/404'
import { Loading } from '../../reusable/Loading'
import { Page } from '../../templates/Page'

const PageScreen = () => {
  const { pathname } = useLocation()
  const slug = pathname.split('/', 3)[2]
  const lang = useRecoilValue(locale)
  const { data, isValidating } = useSWR<IPageResponse>(URI.getPageUri(slug, lang))

  return (
    <PageWrapper>
      {isValidating && <Loading />}
      {!!data?.data.length ? <Page data={data.data[0]} /> : <Error404 />}
    </PageWrapper>
  )
}

export default PageScreen
